import { gql } from '@apollo/client';
import { useState } from 'react';

import { useQuery } from '@fhs/client';
import { useAuthContext } from '@fhs-legacy/frontend/src/state/auth';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';

import { GetGiftCardDataPayload } from '../utils/types';

const GetGiftCardDataQuery = gql`
  query GetGiftCardData @gateway @authRequired {
    getGiftCardData {
      giftCardData {
        cardNumber
        accountIdentifier
        pin
      }
    }
  }
`;

export const useGetGiftCardDataQuery = () => {
  const { user } = useAuthContext();

  return useQuery({
    queryKey: ['getGiftCardData', user?.cognitoId],
    queryFn: async () => {
      const { data } = await client.query({
        query: GetGiftCardDataQuery,
      });
      return data?.getGiftCardData as GetGiftCardDataPayload;
    },
  });
};

export const useLazyGetGiftCardDataQuery = () => {
  const { user } = useAuthContext();
  const [isEnabled, setIsEnabled] = useState(false);

  const query = useQuery({
    enabled: isEnabled,
    queryKey: ['getGiftCardData', user?.cognitoId],
    queryFn: async () => {
      const { data } = await client.query({
        query: GetGiftCardDataQuery,
      });
      return data?.getGiftCardData as GetGiftCardDataPayload;
    },
  });

  return {
    query,
    doQuery: () => setIsEnabled(true),
  };
};
